import { render, staticRenderFns } from "./TenderListComponent.vue?vue&type=template&id=ca5080e0"
import script from "./TenderListComponent.vue?vue&type=script&lang=js"
export * from "./TenderListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports